export const MAX_LENGTH_REF_PI = 40;
